//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import InquiryForm from '~/components/search/inquiry/mixins/InquiryForm'

import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, minValue, numeric} from "vuelidate/lib/validators";
import { BFormGroup, BFormRadioGroup, BFormRadio, BFormInput, BFormSelect, BFormTextarea } from 'bootstrap-vue'

import Vue from 'vue'
import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';
Vue.use(VueFileAgent)

export default {

    name: 'InquiryProjectForm2',

    mixins: [validationMixin, InquiryForm],

    components: { BFormGroup, BFormRadioGroup, BFormRadio, BFormInput, BFormSelect, BFormTextarea },

    props: {
        project: {
        },
        projectTypes: {
        },
    },

    data() {
      return {
          uploadUrl: this.$ziggy.route('search.inquiry.uploadfile'),
          uploadHeaders: { 'X-XSRF-TOKEN': this.$helper.getXSRFToken() },
      }
    },

    validations: {
        project: {
            travelOfAttendees: {
                required
            },
            projectType: {
                required
            },
            projectName: {
            },
            specialRequirements: {
                required
            },
            activities: {
                required
            },
        }
    },
}

